export var getSelectedColumnIndexes = function getSelectedColumnIndexes(selectionRect) {
  var columnIndexes = [];
  for (var i = selectionRect.left; i < selectionRect.right; i++) {
    columnIndexes.push(i);
  }
  return columnIndexes;
};
export var getSelectedRowIndexes = function getSelectedRowIndexes(selectionRect) {
  var rowIndexes = [];
  for (var i = selectionRect.top; i < selectionRect.bottom; i++) {
    rowIndexes.push(i);
  }
  return rowIndexes;
};